




class ColorUtil
{

  static componentToHex(c)
  {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  static rgbToHex(r, g, b)
  {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  static hexToRgb(hex)
  {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  static hexToRgbString(hex)
  {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? parseInt(result[1], 16)+','+parseInt(result[2], 16)+','+parseInt(result[3], 16) : null;
  }

  static lightenDarkenColor(colorCode, amount)
  {
      var usePound = false;
      if (colorCode[0] == "#") {
          colorCode = colorCode.slice(1);
          usePound = true;
      }
      var num = parseInt(colorCode, 16);
      var r = (num >> 16) + amount;
      if (r > 255) {
          r = 255;
      } else if (r < 0) {
          r = 0;
      }
      var b = ((num >> 8) & 0x00FF) + amount;
      if (b > 255) {
          b = 255;
      } else if (b < 0) {
          b = 0;
      }
      var g = (num & 0x0000FF) + amount;
      if (g > 255) {
          g = 255;
      } else if (g < 0) {
          g = 0;
      }
      var string = (g | (b << 8) | (r << 16)).toString(16);
      while (string.length < 6) {
        string = '0'+string;
      }
      return (usePound ? "#" : "") + string;
  }

  static lightOrDark(color)
  {
      // Variables for red, green, blue values
      var r, g, b, hsp;
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
      // If RGB --> store the red, green, blue values in separate variables
          color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
          r = color[1];
          g = color[2];
          b = color[3];
      } else {
          // If hex --> Convert it to RGB: http://gist.github.com/983661
          color = +("0x" + color.slice(1).replace(
          color.length < 5 && /./g, '$&$&'));
          r = color >> 16;
          g = color >> 8 & 255;
          b = color & 255;
      }
      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
      );
      // Using the HSP value, determine whether the color is light or dark
      if (hsp>127.5) {
          return 'light';
      } else {
          return 'dark';
      }
  }

  static luminosity(color)
  {
      // Variables for red, green, blue values
      var r, g, b, hsp;
      // Check the format of the color, HEX or RGB?
      if (color.match(/^rgb/)) {
      // If RGB --> store the red, green, blue values in separate variables
          color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
          r = color[1];
          g = color[2];
          b = color[3];
      } else {
          // If hex --> Convert it to RGB: http://gist.github.com/983661
          color = +("0x" + color.slice(1).replace(
          color.length < 5 && /./g, '$&$&'));
          r = color >> 16;
          g = color >> 8 & 255;
          b = color & 255;
      }
      // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
      hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
      );
      var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      return luma;
  }


}

export default ColorUtil;



